<script>
  import Overview from "./MessageCampaignTabs/Overview.svelte";
  import {External, M} from "../external";
  import Stats from "../Store/Stats/Stats.svelte";
  import {buildSalesUTMFilters} from "../Store/static";

  export let data;

  let tab = "overview", instance;
  let filters, activePeriod, funnelId;

  if (data.data.salesUtm) {
    filters = buildSalesUTMFilters(data.data.salesUtm);
    activePeriod = {
      label: M.LAST_SEVEN_DAYS,
      id: "7-days",
      from: new Date(data.modified.epochSecond * 1000),
      to: new Date()
    };
    funnelId = External.Website.getActiveFunnel()?.id;
  }

  let switchTab = function (t) {
    tab = t;
  };

</script>

<div class="content-wrapper members-content-wrapper">
  <div class="sections-wrapper members-wrapper email-campaign-wrapper">
    <ul class="upper-navigation upper-navigation-full">
      {#if data.data.salesUtm}
        <li><a on:click|preventDefault={() => switchTab("overview")} class:active={tab === "overview"}>{M.OVERVIEW}</a></li>
        <li><a on:click|preventDefault={() => switchTab("sales")} class:active={tab === "sales"}>{M.SALES}</a></li>
      {/if}
    </ul>

    {#if tab === "overview"}
      <Overview bind:data bind:this={instance}/>
    {:else if tab === "sales"}
      <Stats bind:this={instance} filters={filters} period={activePeriod} funnelId={funnelId} />
    {/if}
  </div>
</div>
